import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { noop } from 'lodash-es';
import { Button } from 'reactstrap';

function BackButtonUI({ className = '', onClick = noop }) {
  return (
    <Button
      color="link"
      className={classNames('text-capitalize px-0 text-primary-darker', className)}
      data-testid="back-btn"
      onClick={onClick}
    >
      Back
    </Button>
  );
}

BackButtonUI.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export const BackButton = React.memo(BackButtonUI);
